import "./Home.css";
import { Container, Card, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";

/*
Icon Imports
*/
import caffeine from "./Images/caffeine.png";
import advisor from "./Images/advisor.png";
import bks from "./Images/bks.jpg";
import dock from "./Images/dock.jpg";
import sea from "./Images/sea.jpg";
import amis from "./Images/amis.png";
import wiki from "./Images/wiki.jpg";
import cc from "./Images/cc.png";
import lsd from "./Images/lsd.png";
import aws from "./Images/aws.png";
import files from "./Images/files.png"
import files2 from "./Images/files2.png"
import docs from "./Images/docs.png"
import props from "./Images/props.png"
import tldr from  "./Images/tldr.png"
import excipients from "./Images/excipients.png"
import irwinlab from "./Images/irwinlab.png"
import cartblanche from "./Images/cartblance.png"
import zinc12 from "./Images/zinc12.jpg"
import zinc15 from "./Images/zinc15.svg"
import zinc20 from "./Images/zinc20.svg"
import blaster from "./Images/blaster.png"
import dude from "./Images/dude.jpg"
import dudez from "./Images/dude-z.png"
import dock_github from ".//Images/dock_github.jpeg"
import bb_sw from "./Images/bb_sw.png"
import cc_sw from "./Images/cc_sw.png"
import public_sw from "./Images/public_sw.png"
import private_sw from "./Images/private_sw.png"
import bb_arthor from "./Images/bb_arthor.png"
import cc_arthor from "./Images/cc_arthor.png"
import public_arthor from "./Images/public_arthor.png"
import private_arthor from "./Images/private_arthor.png"
import covalent_arthor from "./Images/covalent_arthor.png"

function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const year = new Date().getFullYear();
  
  // Add resize listener
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determine columns based on screen size
  const getColumnCount = () => {
    if (windowWidth < 576) return 1;      // Mobile
    if (windowWidth < 768) return 2;      // Small tablets
    if (windowWidth < 992) return 3;      // Large tablets
    if (windowWidth < 1200) return 4;     // Small desktops
    return 5;                             // Large desktops
  };

  const websiteInfo = [
    {
      name: "Amis",
      description:
        `A Mouse Imaging Server (AMIS) hosts data generated by 
        the NIH Common fund Program for Illuminating the Druggable Genome 
        (IDG).  These images reveal the distribution of expressed proteins in 
        tissues at high resolution, allowing investigation of the spatial distribution 
        of these gene products.`,
      url: "https://amis.docking.org/",
      img: amis,
    },
    {
      name: "Cartblanche",
      description:
        `Cartblanche is an interface to ZINC-22, containing over 100 billion 2D
        and 10 billion 3D molecules, all commercially available.  ZINC-22 is
        free to everyone to use and download.`,
      url: "https://cartblanche22.docking.org/",
      img: cartblanche,
    },
    {
      name: "Irwin Lab",
      description: `
        We develop software tools and databases for ligand discovery and systems pharmacology.
        `,
      url: "https://irwinlab.compbio.ucsf.edu/",
      img: irwinlab,
    },
    {
      name: "SEA",
      description:
        `
        The Similarity ensemble approach relates proteins based on the set-wise 
        chemical similarity among their ligands.
        `,
      url: "https://sea.docking.org/",
      img: sea,
    },
    {
      name: "Wiki",
      description: 
        `
        This wiki is our documentation (see also DOCS).  If you mange to find
        a rare or tiny mistale, whether it is deliferate or not, you can fix
        it. yourself.`,
      url: "https://wiki.docking.org/index.php?title=Main_Page",
      img: wiki,
    },
    {
      name: "TLDR",
      description:
        `
        TLDR is a Ligand Discovery Resources.  A public access service for
        computational ligand discovery.
        `,
      url: "https://tldr.docking.org/",
      img: tldr,
    },
    {
      name: "Excipients",
      description:
        "The goal of the project is to curate and disseminate information about excipients, the assumed-inactive substances found in food and drugs.",
      url: "https://excipients.docking.org/",
      img: excipients,
    },
    {
      name: "Aggregator Advisor",
      description:
        `Aggregator Advisor identifies molecules that are known to form 
        aggregates, or may form aggregates in biochemical assays.  These can 
        inhibit proteins non-specifically, wasting the investigator's time and 
        money.`,
      url: "https://advisor.docking.org/",
      img: advisor,
    },
    {
      name: "LSD",
      description:
        "Large Scale Docking (LSD) refers to screening of virtual compound libraries (ZINC15, ZINC22) using the DOCK3.7/3.8 software.",
      url: "https://lsd.docking.org/",
      img: lsd,
    },
    {
      name: "Smallworld Public",
      description:
        "SmallWorld is a chemical database indexing technology that enables rapid 2D similarity queries based upon Graph Edit Distance (GED).",
      url: "https://sw.docking.org/search.html",
      img: public_sw,
    },
    {
      name: "Smallworld Private",
      description:
        `
        The private Smallworld databases protects molecules from being
        disclosed on the internet and becoming unpatentable. The password is
        in the supporting information of the ZINC-22 JCIM paper. Billions and
        billions served...
        `,
      url: "https://swp.docking.org/search.html",
      img: private_sw,
    },
    {
      name: "Smallworld Building Blocks",
      description:
        `
        Use SWBB to search for reagents for sale at the gram scale, both in
        stock and make-on-demand.  We thank NextMove Software for access to
        and support of Smallworld.
        `,
      url: "https://swbb.docking.org/search.html",
      img: bb_sw,
    },
    {
      name: "Smallworld Chemistry Commons",
      description:
        `
        Biologists and Medicinal Chemists! Use SWCC to search bespoke
        chemistry that can be synthesized in one or two steps from purchasable
        reagents you find in SWBB. Powered by NextMove!
        `,
      url: "https://swcc.docking.org/search.html",
      img: cc_sw,
    },
    {
      name: "Arthor Public",
      description: `
        Public Arthor hosts databases like ZINC20 among others than can be
        searched almost instantly using three types of search: molecular
        similarity, substructure and pattern matching. Powered by NextMove
        Software!
      `,
      url: "https://arthor.docking.org/index.html",
      img: public_arthor,
    },
    {
      name: "Arthor Private",
      description:
        `The private Arthor databases protects molecules from being disclosed
        on the internet and becoming unpatentable. The password is in the
        supporting information of the ZINC-22 JCIM paper.`,
      url: "https://arthorp.docking.org/index.html",
      img: private_arthor,
    },
    {
      name: "Arthor Building Blocks",
      description:
        `Search commercially available building blocks (reagents) using 
        molecular similarity, substructure or patterns.  Arthor from NextMove 
        Software is amazingly fast and powerful.`,
      url: "https://arthorbb.docking.org/index.html",
      img: bb_arthor,
    },
    {
      name: "Arthor Chemistry Commons",
      description:
        `The Chemistry Commons enumerates compounds that can be made in one or 
        two steps from commercially available building blocks. These 
        collections may be searched using NextMove's Arthor, a fast and 
        powerful search engine for similarity, substructure and patterns.`,
      url: "https://arthorcc.docking.org/index.html",
      img: cc_arthor,
    },
    {
      name: "Chemistry Commons",
      description:
        "The Chemistry Commons connects synthetic organic chemists with biologists seeking new reagents for biology, each assisted by their medicinal and computational chemistry colleagues.",
      url: "https://commons.docking.org/",
      img: cc,
    },
    {
      name: "ZINC 15",
      description:
        `
        ZINC15 is the old (original) version of ZINC20. It has been frozen
        since 2018, and is made available for reference.
        `,
      url: "https://zinc15.docking.org/",
      img: zinc15,
    },
    {
      name: "ZINC 20",
      description:
        `
        ZINC20 is the latest database of in stock compounds. Updated weekly.
        Molecules in ZINC15 that are not in any catalog may be been deleted
        (if a molecule is missing, look for it in ZINC15)
        `,
      url: "https://zinc20.docking.org/",
      img: zinc20,
    },
    {
      name: "AWS",
      description:
        `ZINC is part of the AWS Open Data Sponsorship Program, for which we 
        are very grateful. You can find both ZINC20 and ZINC-22 on AWS.  The 
        files may be used in the cloud, or downloaded anywhere in the world.`,
      url: "https://aws.amazon.com/marketplace/pp/prodview-cclrxhtx5xibk#resources",
      img: aws,
    },
    {
      name: "Docs",
      description: `
        User Manual for Large-Scale Molecular Docking Screens.
      `,
      url: "https://docs.docking.org/index.html",
      img: docs,
    },
    {
      name: "Files",
      description:
        `A file server that contains static files to support ZINC, DOCK, DUDE, SEA, 
        DOCK Blaster and other products.`,
      url: "https://files.docking.org/",
      img: files,
    },
    {
      name: "Files 2",
      description:
        `A second file server that contains static files to support ZINC, DOCK, DUDE, 
        SEA, DOCK Blaster and other products.`,
      url: "https://files2.docking.org/",
      img: files2,
    },
    {
      name: "Props",
      description:
        "A web service for simplifying the calculation of molecular properties.",
      url: "https://props.docking.org/",
      img: props,
    },
    {
      name: "ZINC 12",
      description:
        `
        A free database of commercially available compounds for virtual
        screening. Somewhat obsolete, but still somewhat interesting for
        historical reference.  First released in 2010 and still running.
        `,
      url: "https://zinc12.docking.org/",
      img: zinc12,
    },
    {
      name: "DOCK Blaster",
      description:
        "A public access service for structure-based ligand discovery. DOCK Blaster aims to answer the question: What small molecules should I purchase and test for activity against my biological target for which I have a structure?",
      url: "https://blaster.docking.org/",
      img: blaster,
    },
    {
      name: "DUDE",
      description: `
        DUDE is a Directory of Useful Decoys, Enhanced.  Released in 2012,
        DUDE has become a popular standard for testing molecular docking, and
        a helpful tool to avoid artifactually good enrichment that can occur.
        DUDE has been largely superceded by DUDE-Z.
        `,
      url: "https://dude.docking.org/",
      img: dude,
    },
    {
      name: "DUDE-Z",
      description:
        "The next generation of DUDE, a directory of useful decoys. DUDE-Z is designed to help benchmark molecular docking programs by providing challenging decoys.",
      url: "https://dudez.docking.org/",
      img: dudez,
    },
    {
      name: "docking.org Github Repos",
      description:
        `The UCSF DOCK / ZINC / systems pharmacology development team develops software 
        and databases for ligand discovery. Almost all our software is open source and 
        available to fork.`,
      url: "https://github.com/docking-org",
      img: dock_github,
    },
    {
      name: "Arthor Covalent",
      description:
        `Commercially available covalent ligands are organized here by warhead
        and searchable using NextMove Software's Arthor program, allowing
        similarity, substructure and pattern search. Powerful!`,
      url: "https://arthorcovalent.docking.org/index.html",
      img: covalent_arthor,
    },
  ];

  const importantWebsites = [
    {
      name: "BKS Lab",
      description:
        "The Shoichet lab seeks to bring chemical reagents to biology, combining computation and experiment.",
      url: "https://bkslab.org/home",
      img: bks,
    },
    {
      name: "DOCK",
      description:
        `DOCK poses and scores small molecules in the binding site of a 3D
        protein model, sampling about a million poses, scoring with a p-chem
        scoring function, retaining the best pose, ranking the database for
        review. Two versions, similar in concept, dissimilar in code: 6.12 and
        3.8.`,
      url: "https://dock.docking.org/index.html",
      img: dock,
    },
  ];

  function sortData(websiteList) {
    return [...websiteList].sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  }

  function chunkData(websiteList) {
    const sortedData = sortData(websiteList);
    const columnCount = getColumnCount();
    const chunks = [];

    for (let i = 0; i < sortedData.length; i += columnCount) {
      chunks.push(sortedData.slice(i, i + columnCount));
    }

    return chunks;
  }

  function ShowCards({ websiteList }) {
    return chunkData(websiteList).map((chunk, rowIndex) => (
      <Row key={`row-${rowIndex}`} className="mb-4 justify-content-center g-3">
        {chunk.map((website, colIndex) => (
          <Col 
            key={website.name + colIndex} 
            xs={12} 
            sm={6} 
            md={getColumnCount() === 3 ? 4 : 6} 
            lg={getColumnCount() === 5 ? 2 : 3}
          >
            <Card
              onClick={() => window.open(website.url, "_blank")}
              className="h-100"
            >
              <div className="card-image-container">
                <Card.Img
                  className="card-image"
                  src={website.img ? website.img : caffeine}
                  alt={website.name}
                />
              </div>
              <Card.Header className="centerText">{website.name}</Card.Header>
              <Card.Body className="centerText">
                <Card.Text>{website.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    ));
  }

  return (
    <Container fluid className="hub_container py-4">
      <h1 className="centerText mb-4">
      Welcome to docking.org, software and data from the Shoichet and Irwin
      labs at UCSF!
      </h1>
      
      <div >
        <ShowCards websiteList={importantWebsites} />
      </div>
      
      <div>
        <ShowCards websiteList={websiteInfo} />
      </div>


      {/* 
      
      Footer

      */}
      <footer className="footer centerText">
      < hr />

      <Row >
        <Col>
          <span>
            <a target="_blank" rel="noopener noreferrer" href="https://discord.gg/4MpD6UF5AN">
              Discord
            </a>
            &nbsp;|&nbsp;
            <a target="_blank" rel="noopener noreferrer" href="https://forms.gle/LZV1FCmLWxUWznVi9">Contact Us</a>
            &nbsp;|&nbsp;
            <a target="_blank" rel="noopener noreferrer" href="https://wiki.docking.org/index.php/Privacy_policy">
              Privacy Policy
            </a>
            &nbsp;|&nbsp;
            <a target="_blank" rel="noopener noreferrer" href="https://wiki.docking.org/index.php/Terms_And_Conditions">
              Terms of Use
            </a>
            &nbsp;|&nbsp; © {year} <a target="_blank" rel="noopener noreferrer" href="https://irwinlab.compbio.ucsf.edu/">Irwin</a> and <a target="_blank" rel="noopener noreferrer" href="https://bkslab.org/">Shoichet</a> Labs and the UC Regents
          </span>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="small muted">This is not an official UCSF website. The opinions or statements expressed herein should not be taken as a position of or endorsement by the University of California, San Francisco.</p>

        </Col>
      </Row>
    </footer>
    </Container>
  );
}

export default App;